module.exports = __webpack_public_path__ + "static/info9.d8232033.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Community/info9.png
// module id = 832
// module chunks = 68530290604204